import { useDispatch } from 'react-redux';
import { DIRTY_TYPE } from '../../../../pages/admin/curator/curatorState';
import { setSelectedColor } from '../../../../redux/slicers/admin/curatorStylesSlicer';
import { updateRawObject } from '../../../../redux/slicers/admin/curatorUnityObjectSlicer';
import { useUnityContext } from '../../../container/unityContainer';

export const useUnityColors = ({ applyToUnity = true } = {}) => {
  const dispatch = useDispatch();
  const unity = useUnityContext();

  const changeColor = (color) => {
    const hex = typeof color === 'string' ? color : color.hex;

    if (applyToUnity) {
      unity.materialModule.OnUpdateColorReceiver(hex);
    }

    dispatch(setSelectedColor(color));
    dispatch(
      updateRawObject({
        isColor: true,
        isTextureChanged: false,
      })
    );

    unity.setDataNotSaved({ type: DIRTY_TYPE.MATERIAL_PROPERTIES });
  };

  return {
    changeColor,
  };
};
